import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { CARD_STATUS } from '../enums';

@Pipe({
  name: 'cardStatus'
})
export class CardStatusPipe extends EnumConverter implements PipeTransform {
  enumeration = CARD_STATUS;
}
